(function () {
  const SITE_MAP = {
    'KZ': { domain: 'https://12storeez.kz', name: 'Kazakhstan' },
    'UZ': { domain: 'https://12storeez.uz', name: 'Uzbekistan' },
  };

  const DEFAULT_SITE = { domain: 'https://12storeez.store', name: 'international' };

  function getCurrentSiteKey() {
    const hostname = window.location.hostname;

    if (hostname.includes('12storeez.kz')) return 'KZ';
    if (hostname.includes('12storeez.uz')) return 'UZ';

    return 'OTHER';
  }

  function getTargetSite(countryCode) {
    const code = countryCode.toUpperCase();
    return SITE_MAP[code] || null;
  }

  function isBot() {
    const botPatterns = [
      'googlebot', 'google-inspectiontool', 'storebot-google',
      'bingbot', 'slurp', 'duckduckbot', 'baiduspider',
      'yandexbot', 'facebookexternalhit', 'facebot', 'twitterbot',
      'linkedinbot', 'pinterest', 'semrushbot', 'ahrefsbot',
      'applebot', 'petalbot', 'mj12bot', 'dotbot'
    ];
    var ua = navigator.userAgent.toLowerCase();
    return botPatterns.some(function (bot) { return ua.includes(bot); });
  }

  function shouldSkip() {
    var params = new URLSearchParams(window.location.search);

    if (params.has('noredirect')) {
      sessionStorage.setItem('geo_redirect_noredirect', 'true');
      return true;
    }

    if (sessionStorage.getItem('geo_redirect_noredirect') === 'true') return true;
    if (sessionStorage.getItem('geo_redirect_popup_shown') === 'true') return true;

    return false;
  }

  function markAsShown() {
    sessionStorage.setItem('geo_redirect_popup_shown', 'true');
  }

  function buildRedirectUrl(targetDomain) {
    return targetDomain + window.location.pathname + window.location.search;
  }

  function showPopup(currentSiteName, targetSiteName, targetUrl) {
    var modal = document.getElementById('js-geoRedirectPopup');
    if (!modal) return;

    var titleEl = modal.querySelector('[data-geo-popup-title]');
    var descriptionEl = modal.querySelector('[data-geo-popup-description]');
    var stayBtn = modal.querySelector('[data-geo-popup-stay]');
    var redirectBtn = modal.querySelector('[data-geo-popup-redirect]');
    var closeBtn = modal.querySelector('[data-geo-popup-close]');

    if (titleEl) {
      titleEl.textContent = 'You are on the ' + currentSiteName + ' site';
    }
    if (descriptionEl) {
      descriptionEl.textContent = 'It looks like you are in ' + targetSiteName + '. Would you like to go to the ' + targetSiteName + ' site for better experience?';
    }
    if (stayBtn) {
      stayBtn.textContent = 'Stay on this site';
    }
    if (redirectBtn) {
      redirectBtn.textContent = 'Go to ' + targetSiteName + ' site';
    }

    function close() {
      modal.classList.remove('modal_open');
      markAsShown();
    }

    stayBtn.addEventListener('click', close);
    closeBtn.addEventListener('click', close);

    modal.addEventListener('click', function (event) {
      if (!modal.querySelector('.modal__inner').contains(event.target)) {
        close();
      }
    });

    redirectBtn.addEventListener('click', function () {
      markAsShown();
      window.location.href = targetUrl;
    });

    modal.classList.add('modal_open');
  }

  async function init() {
    if (isBot()) return;
    if (shouldSkip()) return;

    try {
      var response = await fetch('/browsing_context_suggestions.json');
      var data = await response.json();

      if (!data || !data.detected_values || !data.detected_values.country) return;

      var detectedCountry = data.detected_values.country.handle.toUpperCase();
      var currentSiteKey = getCurrentSiteKey();

      // Determine the correct site for the detected country
      var targetSiteInfo = getTargetSite(detectedCountry);

      // If detected country is KZ or UZ, the target is that specific site
      // Otherwise, the target is 12storeez.store (the international site)
      var targetKey;
      if (targetSiteInfo) {
        targetKey = detectedCountry; // KZ or UZ
      } else {
        targetKey = 'OTHER';
      }

      // If user is already on the correct site, do nothing
      if (currentSiteKey === targetKey) return;

      // Determine display names and redirect URL
      var currentSiteName, targetSiteName, targetUrl;

      if (currentSiteKey === 'KZ') {
        currentSiteName = SITE_MAP['KZ'].name;
      } else if (currentSiteKey === 'UZ') {
        currentSiteName = SITE_MAP['UZ'].name;
      } else {
        currentSiteName = DEFAULT_SITE.name;
      }

      if (targetKey === 'KZ' || targetKey === 'UZ') {
        targetSiteName = SITE_MAP[targetKey].name;
        targetUrl = buildRedirectUrl(SITE_MAP[targetKey].domain);
      } else {
        targetSiteName = DEFAULT_SITE.name;
        targetUrl = buildRedirectUrl(DEFAULT_SITE.domain);
      }

      showPopup(currentSiteName, targetSiteName, targetUrl);
    } catch (error) {
      console.error('Geo redirect popup error:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
